var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChevronLeft = function SvgIconChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.67 1.965a1.548 1.548 0 0 0-2.072.107l-8.763 8.763a1.546 1.546 0 0 0 0 2.189l8.763 8.764a1.549 1.549 0 0 0 2.189-2.19l-7.668-7.669 7.668-7.668a1.547 1.547 0 0 0 .106-2.072l-.106-.118-.118-.106z",
    fill: "#292A2C",
    fillRule: "evenodd"
  })));
};
export default SvgIconChevronLeft;